import type { App, ObjectPlugin } from 'vue'
// import createIntercom from './intercom'
import { INTERCOM_APP_ID } from '@/entrypoint'

const createIntercom = (appId: string) => {
  const w: any = window
  const ic = w.Intercom
  if (typeof ic === 'function') {
    ic('update', w.intercomSettings)
  } else {
    const d = document
    const i = function (...innerArgs: any[]) {
      i.c(innerArgs)
    }
    i.q = [] as any
    i.c = function (...innerArgs: any[]) {
      i.q.push(innerArgs)
    }
    w.Intercom = i
    const l = function () {
      const s = d.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = 'https://widget.intercom.io/widget/' + appId
      const x = d.getElementsByTagName('script')[0]
      x.parentNode?.insertBefore(s, x)
    }
    if (document.readyState === 'complete') {
      l()
    } else if (w.attachEvent) {
      w.attachEvent('onload', l)
    } else {
      w.addEventListener('load', l, false)
    }
  }

  return w.Intercom
}

export const IntercomPlugin: ObjectPlugin = {
  install(app: App) {
    window.intercomSettings = {
      app_id: INTERCOM_APP_ID
    }

    app.config.globalProperties.$intercom = createIntercom(INTERCOM_APP_ID)
  }
}
